const state = {
    comparatorProducts: [],
    isUpdated: false
};

const getters = {
    comparatorProducts: state => state.comparatorProducts,
    isUpdated: state => state.isUpdated
};

const mutations = {
    setComparatorProducts: (state, data) => state.comparatorProducts = data,
    setIsUpdated: (state, data) => state.isUpdated = data
};

const actions = {
    getComparatorProducts: (context, data) => {
        let products = window.localStorage.getItem("Comparator") != null ? JSON.parse(window.localStorage.getItem("Comparator")) : [];
        context.commit("setComparatorProducts", products);
        return products;
    },
    addEntry: (context, data) => {
        let products = context.getters["comparatorProducts"];
        if (products.every(x => x.bremboCode !== data.bremboCode)) {
            // Svuota la lista se aggiungo un prodotto di tipo o sottotipo diverso
            if (products.length !== 0 && data.catalogue === "car" && (products[0].productType !== data.productType || products[0].productSubType !== data.productSubType)) {
                products = [];
            } else if (products.length !== 0 && data.catalogue === "bike" && products[0].productType !== data.productType) {
                products = [];
            }

            products.unshift(data);

            if (products.length > 4) {
                products.splice(4);
            }
        }

        window.localStorage.setItem("Comparator", JSON.stringify(products));
        context.commit("setComparatorProducts", products);
        context.commit("setIsUpdated", !context.getters["isUpdated"]);
        return products;
    },
    removeEntry: (context, data) => {
        let products = context.getters["comparatorProducts"];

        if (products.some(x => x.bremboCode === data.bremboCode)) {
            products = products.filter(x => x.bremboCode !== data.bremboCode);
        }

        window.localStorage.setItem("Comparator", JSON.stringify(products));
        context.commit("setComparatorProducts", products);
        context.commit("setIsUpdated", !context.getters["isUpdated"]);


        return products;
    },
    removeAllEntry: (context, data) => {
        context.commit("setComparatorProducts", []);
        context.commit("setIsUpdated", !context.getters["isUpdated"]);
        window.localStorage.removeItem("Comparator");
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};